import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Welcome to 7Founders", -1)
const _hoisted_3 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", _hoisted_3, " You are signed in as a " + _toDisplayString(_ctx.userRole === 2 ? "expert" : "founder"), 1)
  ]))
}